import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Bookings = () => {
    const { id } = useParams();
    
    const rooms = [
        { id: 1, name: "Baphuthi", feature: "Transparent Shower", price: 900 },
        { id: 2, name: "Makholokoe", feature: "Transparent Shower", price: 900 },
        { id: 3, name: "Makhoakhoa", feature: "Black Shower Door", price: 1000 },
        { id: 4, name: "Basia", feature: "Private Bathtub", price: 950 },
        { id: 5, name: "Batlokoa", feature: "Private Bathtub", price: 950 },
        { id: 6, name: "Bafokeng", feature: "Black Shower Door", price: 1000 },
        { id: 7, name: "Bataung", feature: "Black Shower Door", price: 1000 },
        { id: 8, name: "Bakoena", feature: "Black Shower Door", price: 1000 }
    ];

    const [formData, setFormData] = useState({
        guest_name: '',
        guest_email: '',
        guest_phone: '',
        check_in: '',
        check_out: '',
        guests: 1
    });

    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const room = rooms.find(r => r.id === parseInt(id));

    if (!room) {
        return (
            <div>
                <Header />
                <div style={{ textAlign: 'center', padding: '100px' }}>
                    <h2>Room Not Found</h2>
                    <p>The room you're looking for doesn't exist.</p>
                    <a href="/rooms">Back to Rooms</a>
                </div>
                <Footer />
            </div>
        );
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const calculateNights = () => {
        if (!formData.check_in || !formData.check_out) return 1;
        const checkIn = new Date(formData.check_in);
        const checkOut = new Date(formData.check_out);
        const nights = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24));
        return nights > 0 ? nights : 1;
    };

    const totalAmount = room.price * calculateNights();
    const depositAmount = totalAmount * 0.5; // 50% deposit

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

       try {
    const response = await fetch('https://maisonmosh.co.ls/backend/api/bookings.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            room_id: room.id, 
            ...formData, 
            total_amount: totalAmount 
        })
    });

            const data = await response.json();
            
            if (data.success) {
                setStatus({ type: 'success', message: '✓ Booking request sent! We will contact you within 24 hours with payment instructions to secure your 50% deposit.' });
                setFormData({ guest_name: '', guest_email: '', guest_phone: '', check_in: '', check_out: '', guests: 1 });
            } else {
                setStatus({ type: 'error', message: data.message || 'Something went wrong' });
            }
        } catch (error) {
            setStatus({ type: 'error', message: 'Network error. Please try again.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div style={{ maxWidth: '600px', margin: '80px auto', padding: '20px' }}>
                <h2>Book {room.name}</h2>
                <p style={{ marginBottom: '5px' }}>{room.feature}</p>
                <p style={{ marginBottom: '30px' }}>M{room.price} per night</p>
                
                {/* Info box about deposit policy */}
                <div style={{ background: '#e8f4fd', padding: '15px', borderRadius: '5px', marginBottom: '20px', borderLeft: '4px solid #a58e7c' }}>
                    <p style={{ margin: 0, fontSize: '14px', color: '#2c3e50' }}>
                        <strong>📋 Booking Process:</strong><br />
                        1. Submit this booking request<br />
                        2. We'll confirm availability and send payment details<br />
                        3. Pay 50% deposit to secure your room<br />
                        4. Balance due on arrival
                    </p>
                </div>
                
                {status.message && (
                    <div style={{ padding: '12px', marginBottom: '20px', background: status.type === 'success' ? '#d4edda' : '#f8d7da', color: status.type === 'success' ? '#155724' : '#721c24', borderRadius: '5px' }}>
                        {status.message}
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px' }}>
                        <input type="text" name="guest_name" placeholder="Full Name" value={formData.guest_name} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <input type="email" name="guest_email" placeholder="Email Address" value={formData.guest_email} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <input type="tel" name="guest_phone" placeholder="Phone Number" value={formData.guest_phone} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                    </div>
                    
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                        <input type="date" name="check_in" placeholder="Check In" value={formData.check_in} onChange={handleChange} required style={{ width: '50%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                        <input type="date" name="check_out" placeholder="Check Out" value={formData.check_out} onChange={handleChange} required style={{ width: '50%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                    </div>
                    
                    <div style={{ marginBottom: '25px' }}>
                        <select name="guests" value={formData.guests} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }}>
                            <option value="1">1 Guest</option>
                            <option value="2">2 Guests</option>
                            <option value="3">3 Guests</option>
                            <option value="4">4+ Guests</option>
                        </select>
                    </div>
                    
                    <div style={{ background: '#f5f0eb', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                            <span>Total Stay:</span>
                            <strong>M{totalAmount}</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px', borderTop: '1px solid #ddd' }}>
                            <span>Deposit Required (50%):</span>
                            <strong style={{ color: '#a58e7c' }}>M{depositAmount}</strong>
                        </div>
                    </div>
                    
                    <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: '#a58e7c', color: 'white', border: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>
                        {loading ? 'Submitting...' : `Send Booking Request`}
                    </button>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default Bookings;